<header>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
    <div class="container-fluid">
      <a class="navbar-brand" [routerLink]="['/']"><img src="/assets/img/logo.png" style="width:175px; height:auto;" /></a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target=".navbar-collapse"
        aria-label="Toggle navigation"
        [attr.aria-expanded]="isExpanded"
        (click)="toggle()"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse"
        [ngClass]="{ show: isExpanded }"
      >
        <app-login-menu></app-login-menu>
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link text-dark" [routerLink]="['/']">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" *ngIf="isSubscriber | async">
            <a class="nav-link text-dark" [routerLink]="['/labels']">Labels</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" *ngIf="isSubscriber | async">
              <a class="nav-link text-dark" [routerLink]="['/regels']">Aanvragen</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
